import * as React from 'react';

export const AuthContext = React.createContext({
	signinRedirectCallback: () => ({}),
	logout: () => ({}),
	signoutRedirectCallback: () => ({}),
	isAuthenticated: () => ({}),
	signinRedirect: (returnUrl?: string) => ({ returnUrl }),
	signinSilentCallback: () => ({}),
	createSigninRequest: () => ({}),
	signinRedirectJoin: () => ({}),
});
